<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button *ngIf="showHeaderCloseButton" type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
  <input class="form-control w-100" type="text" [(ngModel)]="returnValue" (keydown.enter)="activeModal.close()" />
</div>
<div class="modal-footer">
  <button type="button" class="btn" (click)="activeModal.dismiss()">
    {{ rejectButtonText }}
  </button>

  <button type="button" class="btn btn-primary" (click)="activeModal.close()" [disabled]="!returnValue">
    {{ confirmButtonText }}
  </button>
</div>
